import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteDeleteCateringMenu() {
  return useRemoteMutation<void, RemoteApiError, { ids: number[] }>({
    key: ["delete-catering-menu"],
    url: `/booking-services/delete`,
    method: "post",
    snackbarTextFunOnFail: error => `${(error as any).response.data.message}`
  });
}
